import { useTranslation } from "react-i18next";
import { Fragment, useState } from "react";
import { getDisplayDatetime } from "../../helpers/display_help";
import { PhotoModal } from "./PhotoModal";
import { getCompaniesDeviceRecordUpdatePhotoByAdmin } from "../../services/admin";

function AdminDeviceRecordRow(props) {
    const { t } = useTranslation();
    const data = props.data;

    const [isOpen, setIsOpen] = useState(false);
    const [photos, setPhotos] = useState([]);

    const toggle = () => setIsOpen(!isOpen);

    const handlePhotoClick = async () => {
        const result = await getCompaniesDeviceRecordUpdatePhotoByAdmin(data["id"]);
        if (Array.isArray(result) && result.length > 0) {
            setPhotos(result.map(photo => photo.url));
            setIsOpen(true);
        }
    };

    return (
        <Fragment>
            <tr>
                {props.isIssueUpdate?null:<td style={{ width: 40 }} className="fw-medium">{data["admin_device_id"]}</td>}
                {props.isIssueUpdate?null:<td style={{ width: 40 }} className="fw-medium">{data["device"]===null?"":data["device"]["monitor_location_device_id"]}</td>}
                {props.isIssueUpdate?null:<td style={{ width: 200 }}>{data["device"]===null?"":data["device"]["admin_company"]["name"]}</td>}
                <td style={{ width: 200 }}>{getDisplayDatetime(data["created_at_epoch"] * 1000)}</td>
                {props.isIssueUpdate?null:<td style={{ width: 40 }} className="fw-medium">{data["admin_device_issue_id"]}</td>}
                <td>
                    <textarea
                        value={data["info"] || ""}
                        readOnly
                        style={{
                            width: '100%',
                            minHeight: '2.25rem',
                            resize: 'vertical',
                            border: 'none',
                            background: 'transparent',
                            fontSize: 'inherit',
                            fontFamily: 'inherit',
                            padding: 0,
                            outline: 'none',
                            overflow: 'auto'
                        }}
                    />
                </td>
                <td style={{ width: 40 }} className="fw-medium">
                    {data["files"]?
                    <Fragment>
                    <i
                        className="bx bxs-photo-album"
                        style={{ fontSize: "20px", cursor: "pointer" }}
                        onClick={handlePhotoClick}
                    ></i>
                    <PhotoModal isOpen={isOpen} toggle={toggle} photos={photos} /></Fragment>:null}
                </td>
            </tr>
        </Fragment>
    );
}

export default AdminDeviceRecordRow;
